import { FC } from 'react';
import { PreviewPanel } from '@nextgen-web-framework/all';
import { ImageModalPropsTypes } from './types/propTypes';
import styles from './ImageModal.module.scss';

const ImageModal: FC<ImageModalPropsTypes> = (props: ImageModalPropsTypes): JSX.Element => {
  const { children, onCloseModal } = props;
  return (
    <div data-testid="image-modal">
      <PreviewPanel onClose={onCloseModal} className={styles['previewPanelOverride']}>
        {children}
      </PreviewPanel>
    </div>
  );
};

export default ImageModal;
export type { ImageModalPropsTypes };
